import api from '@/services/api'

export async function getExport(url, type, params){
    var targetUrl = `${url}/${type}`
    const { data: res } = await api.get(targetUrl, {
        params,
        responseType: 'blob'
    })
    console.log(res)
    return res
}
